  <!-- 用法
  <Dialog :visible="dialogVisible" :dialogTitle="'消息提示'" v-on:closeDialog="closeDialog" :width="'300px'">
    <div slot="dialog">
      <p>封装的组件</p> //写自己需要的内容
    </div>
  </Dialog>

  dialogVisible:传的Boolean值

   //关闭弹窗
   closeDialog(data) {
      console.log(data);
      this.dialogVisible = data;
    },
  -->

<template>
  <el-dialog :visible="visible" :width="width" :modal-append-to-body="false" :append-to-body="false">
    <div class="headers">
      {{dialogTitle}}
      <i class="el-icon-close cursorPointer" @click="handelClose" v-if="showClose"></i>
    </div>
    <slot name="dialog"></slot>
  </el-dialog>
</template> 

<script>
export default {
  props: {
    visible: Boolean,
    dialogTitle: String,
    width: String,
    showClose: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handelClose() {
      this.$emit("closeDialog", false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.headers {
  width: 100%;
  height: 40px;
  background: #D81212;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  border-radius: 5px 5px 0 0;
  .el-icon-close {
    float: right;
    position: relative;
    top: 12px;
    right: 6px;
  }
}
</style>
<style lang="scss">
.el-dialog {
  border-radius: 5px;
}
.el-dialog__header {
  display: none;
}
.el-dialog__body {
  padding: 0px 0px;
  background-color: transparent;
  border-radius: 5px;
}
.signDialog {
  height: 200px;
  width: 400px;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  .authDscp {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }
  .withInput {
    width: 100%;
    text-align: left;
    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
}
.authHandlerBox {
  width: 240px;
  display: flex;
  justify-content: space-between;
  .button {
    width: 100px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    text-align: center;
    color: #646464;
    border: 1px solid #c8c8c8;
    &:hover {
      background-color: #a5303d;
      border: 1px solid #a5303d;
      color: white;
    }
  }
  .buttonActive {
    color: #D81212;
    border: 1px solid #D81212;
  }
}
</style>
